import { useContext } from "react";
import { useTranslation } from 'react-i18next';
import UserContext from "../../contexts/UserContext";
import FetchUtil from "../../utils/FetchUtil";

export default function FooterNoAuth() {
	const { t , i18n } = useTranslation();
	const userCtx = useContext(UserContext);
	if(userCtx){
		FetchUtil.setUserLanguage(i18n, userCtx);
	}
  	return (
	    <footer className="mybgcolor text-center text-lg-start">
	      <div className="p-2">
	        <div className="row">
	          <div className="col-lg-6 col-md-12 mb-4 mb-md-0 text-white">
	            <i><small></small></i>
	            <br />
	            <small>&copy;2021-2026 IDS. All Rights Reserved</small>
	          </div>
	          <div className="col-lg-6 col-md-12 mb-4 mb-md-0 text-white">
	            <i><small>{t("footer.contactUs")}</small></i>
	            <br />
	            <small><span class="fa fa-envelope"> </span>{t("footer.emailUs")}: <a href="mailto:info@idecisionsciences.com" style={{color: 'azure'}}>info@idecisionsciences.com </a></small>
	          </div>
	        </div>
	      </div>
	    </footer>
	  );
}
